import { createContext, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { isEmpty } from "lodash";

import {
  createLogService,
  createOrderService,
  deleteOrderService,
  editAddressService,
  editDiscountService,
  editOrderService,
  getCategoryItemsService,
  getLogsService,
  getOrderService,
  getOrdersService,
  getPersonnelService,
  getPersonnelsService,
  getServiceService,
  getServicesService,
  getSurveyItemsService,
  getUserAddressesService,
  getUsersService,
  sendSMSToPersonnelService,
  sendSurveyService,
  createInvoiceService,
  sendInvoiceToClientService,
  getFailureRequestItemsService,
  getUserSatisfactionItemsService,
  deleteFailureRequestService,
  createFailureRequestService,
  getFailureRequestCommentItemsService,
  editFailureRequestService,
  getViolationTypeItemsService,
  getViolationResultItemsService,
  getViolationSolvedItemsService,
  getViolationCommentItemsService,
  deleteViolationService,
  createViolationService,
  editViolationService,
  getViolationService,
  getFailureRequestService,
  editInvoiceService,
  sendEducationalSMSService,
  getCancelingReasonService,
  getFailingReasonService,
  getReturnUserStatusService,
  getEmployersService,
  editUserService,
  sendOrderToPersonnelSMSService,
  addOrderCommentService,
  checkDiscountService,
} from "./../../../services/userServices";
import {
  setLoadingFalseAction,
  setLoadingTrueAction,
} from "./../../../redux/actions/loadingActions/loadingActions";
import {
  modalErrorMessage,
  toastErrorMessage,
  toastSuccessMessage,
} from "../../../utils/toastMessage/toastMessage";
import { orderProgressToText } from "../../../utils";

export const orderAdminContext = createContext({
  orders: [],
  setOrders: () => { },
  personnels: [],
  setPersonnels: () => { },
  personnel_order: [],
  setPersonnel_order: () => { },
  deleted_personnel: [],
  setDeleted_personnel: () => { },
  surveyItems: [],
  setSurveyItems: () => { },
  couponInfo: {},
  setCouponInfo: () => { },
  personnel: {},
  setPersonnel: () => { },
  order: {},
  setOrder: () => { },
  client: {},
  setClient: () => { },
  categories: [],
  setCategories: () => { },
  categoriesWithId: '',
  setCategoriesWithId: () => { },
  setFilterCategory: () => { },
  surveyItemsSelected: [],
  setSurveyItemsSelected: () => { },
  values: [],
  setValues: () => { },
  config: {},
  setConfig: () => { },
  employers: [],
  setEmployers: () => { },
  services: [],
  setServices: () => { },
  logs: [],
  setLogs: () => { },
  comments: [],
  setComments: () => { },
  coupon: "",
  setCoupon: () => { },
  search: "",
  setSearch: () => { },
  totalCount: null,
  setTotalCount: () => { },
  pageNumber: null,
  setPageNumber: () => { },
  cities: [],
  setCities: () => { },
  managedCities: [],
  setManagedCities: () => { },
  selectedCities: [],
  setSelectedCities: () => { },
  limit: null,
  setLimit: () => { },
  id: "",
  setId: () => { },
  invoiceId: "",
  setInvoiceId: () => { },
  cancelId: "",
  setCancelId: () => { },
  failingId: "",
  setFailingId: () => { },
  sort_by: "",
  setSort_by: () => { },
  unique_id: "",
  setUnique_id: () => { },
  address_id: "",
  setAddress_id: () => { },
  category: "",
  setCategory: () => { },
  employer: "",
  setEmployer: () => { },
  service: "",
  setService: () => { },
  status: "",
  setStatus: () => { },
  personnelSearch: "",
  setPersonnelSearch: () => { },
  to_date: "",
  setTo_date: () => { },
  from_date: "",
  setFrom_date: () => { },
  lastDay: "",
  setLastDay: () => { },
  personnel_notification: "",
  setPersonnel_notification: () => { },
  isSpecial: "",
  setIsSpecial: () => { },
  rate: null,
  setRate: () => { },
  fee: "",
  setFee: () => { },
  piece: "",
  setPiece: () => { },
  surveyText: "",
  setSurveyText: () => { },
  tax: "",
  setTax: () => { },
  transportation: "",
  setTransportation: () => { },
  extraItems: [],
  setExtraItems: () => { },
  is_official_invoice: null,
  setIs_official_invoice: () => { },
  isTax: null,
  setIsTax: () => { },
  is_official: null,
  setIs_official: () => { },
  useWallet: false,
  setUseWallet: () => { },
  is_paid: false,
  setIs_paid: () => { },
  rechargeWallet: false,
  setRechargeWallet: () => { },
  amount: "",
  setAmount: () => { },
  invoiceMethod: "",
  setInvoiceMethod: () => { },
  ref_num: null,
  setRef_num: () => { },
  description: "",
  setDescription: () => { },
  comment: "",
  setComment: () => { },
  result: "",
  setResult: () => { },
  request_type: "",
  setRequest_type: () => { },
  personnel_id: "",
  setPersonnel_id: () => { },
  old_personnel_id: "",
  setOld_personnel_id: () => { },
  solved_id: "",
  setSolved_id: () => { },
  penalty: "",
  setPenalty: () => { },
  isPenalty: null,
  setIsPenalty: () => { },
  result_id: "",
  setResult_id: () => { },
  customer_satisfaction_item: "",
  setCustomer_satisfaction_item: () => { },
  personnelType: {},
  setPersonnelType: () => { },
  isShowInvoiceModal: null,
  setIsShowInvoiceModal: () => { },
  isShowLogs: null,
  setIsShowLogs: () => { },
  isShowPersonnelModal: null,
  setIsShowPersonnelModal: () => { },
  isPersonnelLoading: null,
  setIsPersonnelLoading: () => { },
  isPositiveTab: null,
  setIsPositiveTab: () => { },
  isShowSurveyModal: null,
  setIsShowSurveyModal: () => { },
  isExistingSurveyItem: () => { },
  users: [],
  setUsers: () => { },
  addresses: [],
  setAddresses: () => { },
  violation: {},
  setViolation: () => { },
  failureRequest: {},
  setFailureRequest: () => { },
  failureRequestItems: [],
  setFailureRequestItems: () => { },
  violationTypeItems: [],
  setViolationTypeItems: () => { },
  violationSolvedItems: [],
  setViolationSolvedItems: () => { },
  violationResultItems: [],
  setViolationResultItems: () => { },
  violationCommentItems: [],
  setViolationCommentItems: () => { },
  userSatisfactionItems: [],
  setUserSatisfactionItems: () => { },
  failureRequestCommentItems: [],
  setFailureRequestCommentItems: () => { },
  cancelingItems: [],
  setCancelingItems: () => { },
  failingReasonItems: [],
  setFailingReasonItems: () => { },
  returnUserStatusItems: [],
  setReturnUserStatusItems: () => { },
  userSearch: "",
  setUserSearch: () => { },
  personnelStep: "",
  setPersonnelStep: () => { },
  admin_notification: "",
  setAdmin_notification: () => { },
  expert_type: "",
  setExpert_type: () => { },
  activity_type: "",
  setActivity_type: () => { },
  isActive: "",
  setIsActive: () => { },
  workCount: "",
  setWorkCount: () => { },
  address: "",
  setAddress: () => { },
  isUserLoading: null,
  setIsUserLoading: () => { },
  isEditAddress: null,
  setIsEditAddress: () => { },
  isShowDetailsModal: null,
  setIsShowDetailsModal: () => { },
  isShowCreateModal: null,
  setIsShowCreateModal: () => { },
  isShowCreateFailureRequestModal: null,
  setIsShowCreateFailureRequestModal: () => { },
  isShowCreateViolationModal: null,
  setIsShowCreateViolationModal: () => { },
  isShowAdvancedSearch: null,
  setIsShowAdvancedSearch: () => { },
  isShowFilter: null,
  setIsShowFilter: () => { },
  isShowCanceling: null,
  setIsShowCanceling: () => { },
  isShowFailing: null,
  setIsShowFailing: () => { },
  isShowEditModal: null,
  setIsShowEditModal: () => { },
  handleShowEditModal: () => { },
  handleCloseEditModal: () => { },
  handleCloseCreateFailureAndViolationModal: () => { },
  handleShowDetailsModal: () => { },
  handleCloseDetailsModal: () => { },
  handleShowCreateModal: () => { },
  handleCloseCreateModal: () => { },
  handleShowInvoiceModal: () => { },
  handleCloseInvoiceModal: () => { },
  handleGetEmployers: () => { },
  handleSearchServices: () => { },
  handleGetServices: () => { },
  handleGetPersonnel: () => { },
  handleGetUsers: () => { },
  handleChangeSurveyItemList: () => { },
  handleShowSurveyModal: () => { },
  handleCloseSurveyModal: () => { },
  handleShowPersonnelModal: () => { },
  handleClosePersonnelModal: () => { },
  handleShowCancelingModal: () => { },
  handleCloseCancelingModal: () => { },
  handleShowFailingModal: () => { },
  handleCloseFailingModal: () => { },
  handleEditPersonnel: () => { },
  handleGetOrders: () => { },
  handleGetOrder: () => { },
  handleDeleteOrder: () => { },
  handleGetCategoryItemList: () => { },
  handleSendSMSToPersonnel: () => { },
  handleSendEducationalSMS: () => { },
  handleSendOrderToPersonnelSMS: () => { },
  handleGetLogsOrder: () => { },
  handleGetPersonnels: () => { },
  handleRemovePersonnel: () => { },
  handleAddPersonnel: () => { },
  handleGetSurveyItemList: () => { },
  handleSendSurvey: () => { },
  handleCreateInvoice: () => { },
  handleEditInvoice: () => { },
  handleEditStatus: () => { },
  handleEditReturnUserStatus: () => { },
  handleEditUser: () => { },
  handleEditAddress: () => { },
  handleSendInvoiceToClient: () => { },
  handleEditDiscount: () => { },
  handleResetState: () => { },
  handleEditValue: () => { },
  handleEditValues: () => { },
  handleCreateOrder: () => { },
  handleGetAddresses: () => { },
  handleGetFailureRequest: () => { },
  handleGetFailureRequestItemList: () => { },
  handleGetUserSatisfactionItemList: () => { },
  handleDeleteFailureRequest: () => { },
  handleCreateFailureRequest: () => { },
  handleEditFailureRequest: () => { },
  handleGetFailureRequestCommentItemList: () => { },
  handleGetViolation: () => { },
  handleDeleteViolation: () => { },
  handleCreateViolation: () => { },
  handleEditViolation: () => { },
  handleRemovePenaltyViolation: () => { },
  handleGetViolationTypeItemList: () => { },
  handleGetViolationResultItemList: () => { },
  handleGetViolationSolvedItemList: () => { },
  handleGetViolationCommentItemList: () => { },
  handleGetCancelingReasonList: () => { },
  handleGetFailingReasonItemList: () => { },
  handleGetReturnUserStatusItemList: () => { },
  handleEditUserInfo: () => { },
  handleAddComment: () => { },
  handleEditProgress: () => { },
  handleResetCoupon: () => { },
  handleCheckDiscount: () => { },
  checkViewOrders: () => { },
  city_filter: "",
  setCity_filter: () => { },
});

const OrderAdminContext = ({
  children,
  isOfficial,
  isWaiting,
  isUserCancel,
  isUserReturn,
}) => {
  const permission = useSelector((state) => state.permission);
  const appConfigs = useSelector((state) => state.appConfigs);
  const userInfo = useSelector((state) => state.userInfo);
  const allCities = useSelector((state) => state.cities);

  // Redux Dispatch
  const dispatch = useDispatch();

  const cacheKeyRef = useRef("");

  const [orders, setOrders] = useState([]);
  const [users, setUsers] = useState([]);
  const [personnels, setPersonnels] = useState([]);
  const [categories, setCategories] = useState([]);
  const [categoriesWithId, setCategoriesWithId] = useState([]);
  const [filterCategory, setFilterCategory] = useState(null);
  const [personnel_order, setPersonnel_order] = useState([]);
  const [deleted_personnel, setDeleted_personnel] = useState([]);
  const [surveyItems, setSurveyItems] = useState([]);
  const [surveyItemsSelected, setSurveyItemsSelected] = useState([]);
  const [values, setValues] = useState([]);
  const [logs, setLogs] = useState([]);
  const [comments, setComments] = useState([]);
  const [employers, setEmployers] = useState([]);
  const [services, setServices] = useState([]);
  const [addresses, setAddresses] = useState([]);
  const [failureRequestItems, setFailureRequestItems] = useState([]);
  const [violationTypeItems, setViolationTypeItems] = useState([]);
  const [violationSolvedItems, setViolationSolvedItems] = useState([]);
  const [violationResultItems, setViolationResultItems] = useState([]);
  const [violationCommentItems, setViolationCommentItems] = useState([]);
  const [userSatisfactionItems, setUserSatisfactionItems] = useState([]);
  const [failureRequestCommentItems, setFailureRequestCommentItems] = useState(
    []
  );
  const [cancelingItems, setCancelingItems] = useState([]);
  const [failingReasonItems, setFailingReasonItems] = useState([]);
  const [returnUserStatusItems, setReturnUserStatusItems] = useState([]);
  const [couponInfo, setCouponInfo] = useState({});
  const [violation, setViolation] = useState({});
  const [failureRequest, setFailureRequest] = useState({});
  const [personnel, setPersonnel] = useState({});
  const [order, setOrder] = useState({});
  const [client, setClient] = useState({});
  const [config, setConfig] = useState({});
  const [cancelId, setCancelId] = useState("");
  const [failingId, setFailingId] = useState("");
  const [search, setSearch] = useState("");
  const [personnelSearch, setPersonnelSearch] = useState("");
  const [admin_notification, setAdmin_notification] = useState("");
  const [expert_type, setExpert_type] = useState("");
  const [activity_type, setActivity_type] = useState("");
  const [isActive, setIsActive] = useState("");
  const [workCount, setWorkCount] = useState(null);
  const [userSearch, setUserSearch] = useState("");
  const [personnelStep, setPersonnelStep] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);
  const [managedCities, setManagedCities] = useState([]);
  const [selectedCities, setSelectedCities] = useState([]);
  const [limit, setLimit] = useState(100);
  const [personnelSort, setPersonnelSort] = useState("");

  const mine = appConfigs.managed_cities;
  useEffect(() => {
    const formattedCities = mine?.map(city => ({
      value: city.id,
      label: city.name
    }));
    if (formattedCities !== managedCities) {
      setSelectedCities(formattedCities);
      setManagedCities(formattedCities);
    }
  }
    , [mine]);
  const [city_filter, setCity_filter] = useState(null);
  const [cities, setCities] = useState([]);
  useEffect(() => {
    if (allCities !== cities) {
      setCities(allCities);
    }
  }
    , [allCities]);
  const [id, setId] = useState("");
  const [invoiceId, setInvoiceId] = useState("");
  const [sort_by, setSort_by] = useState("-created");
  const [unique_id, setUnique_id] = useState("");
  const [address_id, setAddress_id] = useState("");
  const [category, setCategory] = useState("");
  const [employer, setEmployer] = useState("");
  const [service, setService] = useState("");
  const [status, setStatus] = useState("");
  const [to_date, setTo_date] = useState("");
  const [from_date, setFrom_date] = useState("");
  const [lastDay, setLastDay] = useState(3);
  const [comment, setComment] = useState("");
  const [result, setResult] = useState("");
  const [request_type, setRequest_type] = useState("");
  const [personnel_id, setPersonnel_id] = useState("");
  const [old_personnel_id, setOld_personnel_id] = useState("");
  const [solved_id, setSolved_id] = useState("");
  const [penalty, setPenalty] = useState("");
  const [isPenalty, setIsPenalty] = useState(false);
  const [result_id, setResult_id] = useState("");
  const [customer_satisfaction_item, setCustomer_satisfaction_item] =
    useState("");
  const [personnel_notification, setPersonnel_notification] = useState("");
  const [isSpecial, setIsSpecial] = useState("All");
  const [address, setAddress] = useState("");
  const [coupon, setCoupon] = useState("");
  const [fee, setFee] = useState("");
  const [piece, setPiece] = useState("");
  const [surveyText, setSurveyText] = useState("");
  const [transportation, setTransportation] = useState("");
  const [extraItems, setExtraItems] = useState([]);
  const [tax, setTax] = useState("10");
  const [is_official_invoice, setIs_official_invoice] = useState(false);
  const [isTax, setIsTax] = useState(false);
  const [is_official, setIs_official] = useState(false);
  const [useWallet, setUseWallet] = useState(false);
  const [is_paid, setIs_paid] = useState(false);
  const [rechargeWallet, setRechargeWallet] = useState(false);
  const [amount, setAmount] = useState("");
  const [invoiceMethod, setInvoiceMethod] = useState("1");
  const [ref_num, setRef_num] = useState(null);
  const [description, setDescription] = useState("");
  const [personnelType, setPersonnelType] = useState({});
  const [rate, setRate] = useState(0);
  const [isShowCanceling, setIsShowCanceling] = useState(false);
  const [isShowFailing, setIsShowFailing] = useState(false);
  const [isShowInvoiceModal, setIsShowInvoiceModal] = useState(false);
  const [isShowLogs, setIsShowLogs] = useState(false);
  const [isShowPersonnelModal, setIsShowPersonnelModal] = useState(false);
  const [isShowSurveyModal, setIsShowSurveyModal] = useState(false);
  const [isShowDetailsModal, setIsShowDetailsModal] = useState(false);
  const [isPersonnelLoading, setIsPersonnelLoading] = useState(false);
  const [isUserLoading, setIsUserLoading] = useState(false);
  const [isPositiveTab, setIsPositiveTab] = useState(true);
  const [isEditAddress, setIsEditAddress] = useState(false);
  const [isShowCreateModal, setIsShowCreateModal] = useState(false);
  const [isShowCreateFailureRequestModal, setIsShowCreateFailureRequestModal] =
    useState(false);
  const [isShowCreateViolationModal, setIsShowCreateViolationModal] =
    useState(false);
  const [isShowAdvancedSearch, setIsShowAdvancedSearch] = useState(false);
  const [isShowFilter, setIsShowFilter] = useState(false);
  const [isShowEditModal, setIsShowEditModal] = useState(false);

  useEffect(() => {
    handleGetAppConfig();
  }, [appConfigs]);

  // Handle Get App Configs Method
  const handleGetAppConfig = async () => {
    if (appConfigs) {
      const cleanConfig = {};
      cleanConfig.STATUS_CHOICES = appConfigs.STATUS_CHOICES?.split("،");
      cleanConfig.STATUS_CHOICES_USER =
        appConfigs.STATUS_CHOICES_USER?.split("،");
      cleanConfig.PAYMENT_TYPE = appConfigs.PAYMENT_TYPE?.split("،");
      cleanConfig.CITY_CHOICES = appConfigs.CITY_CHOICES?.split("،");
      setConfig({ ...appConfigs, ...cleanConfig });
    }
  };

  // Personnel SMS Text
  const personnelSmsText = () => {
    const datetime = order?.values
      ?.find((_v) => _v?.type === "datetime")
      ?.value?.split(" ");
    return `${datetime[0]}\n${datetime[1]}\n${order?.client?.mobile}\n${order?.client?.first_name
      } ${order?.client?.last_name}\nآدرس: ${order?.address?.address
      }\n\nکدپیگیری:${order.ref_num}\nدرصد تخفیف:${order?.discount?.percent || 0
      }\nکاربامایار عزیز پس از دریافت سفارش برای هماهنگی انجام کار سریعا با مشتری تماس بگیرید!`;
  };

  const handleResetState = () => {
    // setOrder({});
    setCouponInfo({});
    setPersonnel({});
    setClient({});
    setLogs({});
    setPersonnel_notification("");
    setIsSpecial("All");
    setPersonnelSearch("");
    setUserSearch("");
    setPersonnelStep(1);
    setDeleted_personnel([]);
    setPersonnel_order([]);
    setPersonnels([]);
    setIsPositiveTab(true);
    setRate(0);
    setSurveyItemsSelected([]);
    setSurveyText("");
    setAddress("");
    setCoupon("");
    setUnique_id("");
    setAddress_id("");
    setComment("");
    setResult("");
    setSolved_id("");
    setPenalty("");
    setIsPenalty(false);
    setResult_id("");
    setRequest_type("");
    setOld_personnel_id("");
    setPersonnel_id("");
    setCustomer_satisfaction_item("");
    setCancelId("");
    setFailingId("");
    setAddresses([]);
    setFailureRequestItems([]);
    setUserSatisfactionItems([]);
    setViolationTypeItems([]);
    setViolationSolvedItems([]);
    setViolationResultItems([]);
    setViolationCommentItems([]);
    setFailureRequestCommentItems([]);
    setIsShowCanceling(false);
    setIsShowFailing(false);
    setIs_official_invoice(false);
    setCancelingItems([]);
    setFailingReasonItems([]);
    setFailureRequest({});
    setViolation({});
    setAdmin_notification("");
    setExpert_type("");
    setActivity_type("");
    setIsActive("");
    setWorkCount(null);
    setIsEditAddress(false);
    setValues([]);
    setUsers([]);
    setIsShowLogs(false);
    handleCloseInvoiceModal();
    setCity_filter(null);
  };

  const handleResetCoupon = () => {
    setCouponInfo({});
    setCoupon("");
  };

  // Edit Order Modal Operations
  const handleShowEditModal = () => {
    setIsShowEditModal(true);
  };
  const handleCloseEditModal = () => {
    setIsShowEditModal(false);
    handleResetState();
  };

  // Invoice Modal Operations
  const handleShowInvoiceModal = (val) => {
    setIsShowInvoiceModal(true);
    if (val) {
      let totalInvoice =
        Number(val?.fee) +
        Number(val?.piece) +
        Number(val?.transportation) +
        (!isEmpty(val?.items)
          ? val?.items?.map((_item) => Number(_item.price))
          : 0) -
        Number(val?.amount);

      setInvoiceId(val?.pk);
      setFee(val?.fee);
      setPiece(val?.piece);
      setTransportation(val?.transportation);
      setExtraItems(val?.items);
      setIsTax(!!val?.tax);
      setTax((+val?.tax / totalInvoice) * 100 || "10");
      setIs_official(val?.is_official);
      setAmount(val?.amount);
      setInvoiceMethod(val?.method);
      setRef_num(val?.ref_num);
      setDescription(val?.description);
    }
  };

  const handleCloseInvoiceModal = () => {
    setIsShowInvoiceModal(false);
    setInvoiceId("");
    setFee("");
    setPiece("");
    setTransportation("");
    setTax("10");
    setIsTax(false);
    setIs_official(false);
    setUseWallet(false);
    setIs_paid(false);
    setRechargeWallet(false);
    setAmount("");
    setInvoiceMethod("1");
    setRef_num(null);
    setDescription("");
    setExtraItems([]);
  };

  // Status Order Modal Operations
  const handleShowPersonnelModal = (pk) => {
    setIsShowPersonnelModal(true);
    setId(pk);
    setPersonnelType({
      value: order?.service?.id,
      label: order?.service?.name,
    });
    setPersonnel_notification(personnelSmsText());
  };
  const handleClosePersonnelModal = () => {
    setIsShowPersonnelModal(false);
    handleResetState();
  };

  // Survey Order Modal Operations
  const handleShowSurveyModal = () => {
    setIsShowSurveyModal(true);
    if (isEmpty(surveyItems)) handleGetSurveyItemList();
  };
  const handleCloseSurveyModal = () => {
    setIsShowSurveyModal(false);
    // handleResetState();
  };

  // Details Order Modal Operations
  const handleShowDetailsModal = () => {
    setIsShowDetailsModal(true);
  };
  const handleCloseDetailsModal = () => {
    setIsShowDetailsModal(false);
    handleResetState();
  };

  // Create Order Modal Operations
  const handleShowCreateModal = () => {
    setIsShowCreateModal(true);
  };
  const handleCloseCreateModal = () => {
    setIsShowCreateModal(false);
    handleResetState();
  };

  // Canceling Modal
  const handleShowCancelingModal = () => setIsShowCanceling(true);
  const handleCloseCancelingModal = () => {
    setIsShowCanceling(false);
  };

  // Failing Modal
  const handleShowFailingModal = () => setIsShowFailing(true);
  const handleCloseFailingModal = () => {
    setIsShowFailing(false);
  };

  const handleCloseCreateFailureAndViolationModal = () => {
    setViolation({});
    setFailureRequest({});
    setIsShowCreateFailureRequestModal(false);
    setIsShowCreateViolationModal(false);
    setComment("");
    setStatus("");
    setResult("");
    setSolved_id("");
    setIsPenalty(false);
    setResult_id("");
    setRequest_type("");
    setOld_personnel_id("");
    setPersonnel_id("");
    setCustomer_satisfaction_item("");
  };

  // Handle Get Category Item List Method
  const handleGetCategoryItemList = async (event) => {
    event?.preventDefault();

    const objData = { search };

    try {
      const { status, data } = await getCategoryItemsService(objData);
      if (status === 200) {
        setCategories(data?.results?.map((cat) => cat.name));
        setCategoriesWithId(
          data?.list?.map((cat) => ({
            id: cat.id,
            name: cat.name
          })) || []
        );
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
    }
  };

  // Handle Get Orders Method
  const handleGetOrders = async (event) => {
    event?.preventDefault();
    const isSearch = !isEmpty(event);

    let from_dateVal = isEmpty(from_date) ? null : from_date?.split("T")[0];
    let to_dateVal = isEmpty(to_date) ? null : to_date?.split("T")[0];

    if (isShowFilter) {
      from_dateVal = new Date();
      to_dateVal = new Date();
      switch (lastDay) {
        case 1:
          from_dateVal.setDate(from_dateVal.getDate() + 2);
          to_dateVal.setFullYear(from_dateVal.getFullYear() + 1);

          from_dateVal = from_dateVal.toISOString().split("T")[0];
          to_dateVal = to_dateVal.toISOString().split("T")[0];
          break;

        default:
          to_dateVal.setDate(to_dateVal.getDate() - (lastDay - 3));
          from_dateVal = to_dateVal = to_dateVal.toISOString().split("T")[0];
          break;
      }
    }

    const objData = {
      offset: ((isSearch ? 1 : pageNumber) - 1) * limit,
      limit,
      sort_by,
      cities: selectedCities ? selectedCities.map(c => c.value) : [],
      ...(isOfficial && { is_official_invoice: true }),
      ...(isUserCancel && { new_user_cancel: true }),
      ...(isUserReturn && { new_return_users: true }),
      ...(category && { category }),
      ...(employer && { client_type: employer === "null" ? null : employer }),
      ...(service && { service }),
      ...(isWaiting ? { status: 13 } : (status || status === 0) && { status }),
      ...(search && { search }),
      ...(from_dateVal && { from_date: `${from_dateVal} 00:00:00` }),
      ...(to_dateVal && { to_date: `${to_dateVal} 23:59:59` }),
    };

    cacheKeyRef.current = JSON.stringify(objData);
    const currentCacheKey = JSON.stringify(objData);
    const cacheValue = JSON.parse(localStorage.getItem(currentCacheKey));
    if (!isEmpty(cacheValue)) setOrders(cacheValue);
    try {
      if (isEmpty(cacheValue)) dispatch(setLoadingTrueAction());

      const { status, data } = await getOrdersService(objData);
      if (status === 200) {
        const result = data.results;
        if (currentCacheKey === cacheKeyRef.current) {
          setOrders(result?.list);
          setTotalCount(result?.total);
        }
        localStorage.setItem(currentCacheKey, JSON.stringify(result?.list));
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Get Employers Method
  const handleGetEmployers = async () => {
    try {
      const { status, data } = await getEmployersService();
      if (status === 200) {
        setEmployers(data.results);
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
    }
  };

  // Handle Search Services Method
  const handleSearchServices = async (filter, callback) => {
    const objData = {
      search: filter,
      offset: 0,
      limit: 500,
    };

    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await getServicesService(objData);
      if (status === 200) {
        const services = data.list?.map((item) => ({
          value: item.id,
          label: item.name,
        }));

        callback &&
          callback([
            {
              value: null,
              label: "همه",
            },
            ...services,
          ]);
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Get Services Method
  const handleGetServices = async (event) => {
    event?.preventDefault();
    const objData = {
      search: "",
      offset: 0,
      limit: 300,
    };

    try {
      const { status, data } = await getServicesService(objData);
      if (status === 200) {
        setServices(data.list);
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
    }
  };

  // Handle Get Service Method
  const handleGetService = async (unique_id) => {
    const objData = {
      unique_id,
    };

    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await getServiceService(objData);
      if (status === 200) {
        // Convert structure to edit
        const finallyValues = data?.params?.map((_value) => {
          if (_value?.type === "item") {
            return {
              values: [
                {
                  ..._value,
                  order: _value?.order,
                  values: _value?.params?.map((_itemValue) => {
                    return {
                      ..._itemValue,
                      type: _itemValue?.type,
                      parameter: _itemValue?.parameter,
                      value: _itemValue?.default ?? "",
                      order: _itemValue?.order,
                      name: _itemValue?.name,
                      list: _itemValue?.list ?? "",
                    };
                  }),
                },
              ],
              type: _value?.type,
              order: _value?.order,
              name: _value?.name,
            };
          } else {
            return {
              ..._value,
              type: _value?.type,
              parameter: _value?.parameter,
              value: _value?.type === "text" ? " " : _value?.default ?? 0,
              order: _value?.order,
              name: _value?.name,
              list: _value?.list ?? "",
            };
          }
        });

        setValues(finallyValues);
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Create Order Method
  const handleCreateOrder = async () => {
    const message = handleValidationParams(values);

    if (!!message) return toastErrorMessage(message);

    const objData = {
      values,
      unique_id,
      client,
      status: 0,
      client_id: client?.pk,
      address_id,
      is_official_invoice,
    };

    // Check Coupon Id
    if (!isEmpty(couponInfo)) objData.coupon = coupon;

    if (isEmpty(client)) return toastErrorMessage("انتخاب کاربر الزامی میباشد");
    if (isEmpty(address_id.toString()))
      return toastErrorMessage("انتخاب آدرس الزامی میباشد");
    if (isEmpty(unique_id))
      return toastErrorMessage("انتخاب نوع سفارش الزامی میباشد");

    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await createOrderService(objData);
      if (status === 200) {
        toastSuccessMessage("سفارش با موفقیت ایجاد شد");
        handleGetOrders();
        handleCloseCreateModal();
        handleCreateLog(
          data.id,
          `${userInfo.first_name} ${userInfo.last_name} برای ${client.first_name
          } ${client.last_name} با شماره موبایل ${client.mobile} سفارش ${services?.find((_s) => _s.unique_id === unique_id)?.name
          } ایجاد کرد`
        );
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Get Addresses Method
  const handleGetAddresses = async (user_id) => {
    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await getUserAddressesService({
        user_id,
      });
      if (status === 200) {
        setAddresses(data.list);
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage(response?.data?.error);
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Get Order Method
  const handleGetOrder = async (pk, func) => {
    const objData = {
      id: pk,
    };

    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await getOrderService(objData);
      if (status === 200) {
        setOrder(data);
        setId(data?.id);
        setAdmin_notification(data?.admin_notification);
        setAddress(data?.address?.address);
        setComments(data?.comments);
        setIs_official_invoice(data?.is_official_invoice);
        setCancelId(data?.cancelingreason?.id || "");
        setFailingId(data?.failingreason?.id || "");
        setCity_filter(data?.city?.id || "");
        // Survey
        setRate(data?.rating);
        setSurveyItemsSelected(
          data?.surveyitems?.map((_survey) => {
            return { survey_id: _survey?.id };
          })
        );
        setSurveyText(data.feedback);
        // Get Personnels
        const prsnl = data?.personnel?.map((_prsnl) => {
          return { ..._prsnl, personnel_id: _prsnl.id };
        });
        setPersonnel_order(prsnl);
        // Edit Values
        setValues(data?.values);

        // Handle Custom Function
        if (func) {
          func();
        }
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Delete Order Method
  const handleDeleteOrder = async (_item) => {
    const objData = {
      id: _item?.pk,
    };

    try {
      dispatch(setLoadingTrueAction());
      const { status } = await deleteOrderService(objData);
      if (status === 200) {
        toastSuccessMessage(`سفارش  ${_item?.pk} با موفقیت حذف شد`);
        handleGetOrders();
        handleCreateLog(
          null,
          `${userInfo.first_name} ${userInfo.last_name} سفارش ${_item.service} برای ${_item?.client?.first_name} ${_item?.client?.last_name} با شماره موبایل ${_item?.client?.mobile} را حذف کرد`
        );
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Get Personnels Method
  const handleGetPersonnels = async (event) => {
    event?.preventDefault();
    const objData = {
      search: personnelSearch,
      offset: 0,
      limit: 200,
      ...(city_filter && { city: city_filter }),
      ...(!!personnelType.value && { expertise: personnelType.value }),
      ...(!!filterCategory && { service_category: filterCategory }),
      ...(isSpecial !== "All" && { is_special: isSpecial }),
      ...(isActive && { is_active: isActive }),
      ...(workCount && { work_count: workCount }),
      ...(personnelSort && { sort_by: personnelSort }),
      ...(expert_type && {
        expert_type,
      }),
      ...(activity_type && {
        activity_type,
      }),
    };

    try {
      setIsPersonnelLoading(true);
      const { status, data } = await getPersonnelsService(objData);
      if (status === 200) {
        setPersonnels(data.results);
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
    } finally {
      setIsPersonnelLoading(false);
    }
  };

  // Handle Get Personnel Method
  const handleGetPersonnel = async (id) => {
    const objData = {
      id,
    };

    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await getPersonnelService(objData);
      if (status === 200) {
        setPersonnel(data);
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage(response?.data?.error);
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Get Users Method
  const handleGetUsers = async (event) => {
    event?.preventDefault();
    const objData = {
      search: userSearch,
      offset: 0,
      limit: 100,
    };

    try {
      setIsUserLoading(true);
      const { status, data } = await getUsersService(objData);
      if (status === 200) {
        setUsers(data.results);
        setTotalCount(data.count);
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
    } finally {
      setIsUserLoading(false);
    }
  };

  // Handle Edit Personnel Method
  const handleEditPersonnel = async (event) => {
    event?.preventDefault();
    // New Personnel Order filter
    const personnelOrder = [];
    for (let i = 0; i < personnel_order.length; i++) {
      if (personnel_order[i].isNew) {
        personnelOrder.push({ personnel_id: personnel_order[i]?.personnel_id });
      }
    }

    // Personnel Deleted filter
    const deletedPersonnel = deleted_personnel?.map((_prsnl) => {
      return { personnel_id: _prsnl?.personnel_id };
    });
    const objData = {
      ...order,
      personnel_order: personnelOrder,
      deleted_personnel: deletedPersonnel,
    };

    try {
      dispatch(setLoadingTrueAction());
      const { status } = await editOrderService(objData);
      if (status === 200) {
        toastSuccessMessage("پرسنل با موفقیت ویرایش شد");
        if ([0, 1, 2].includes(order.status) && !isEmpty(personnelOrder)) {
          handleEditStatus(order.id, 4);
        } else handleGetOrder(order.id);

        handleCreateLog(
          order.id,
          `${userInfo.first_name} ${userInfo.last_name} پرسنل ${personnel_order
            ?.map(
              (_p) =>
                `${_p?.first_name} ${_p?.last_name} با شماره موبایل ${_p?.mobile} و شناسه ${_p?.personnel_id}`
            )
            ?.toString()} را به سفارش ${order.id} اضافه کرد`
        );

        if (
          permission.personnel_send_sms_to_personnel &&
          !isEmpty(personnelOrder)
        )
          setPersonnelStep(2);
        else handleClosePersonnelModal();
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Send SMS To Personnel Method
  const handleSendSMSToPersonnel = async (event) => {
    event?.preventDefault();

    const objData = { pk: order.id, personnel_notification };

    if (personnel_notification?.trim()?.length <= 0)
      return toastErrorMessage("متن پیامک نمیتواند خالی باشد");

    try {
      dispatch(setLoadingTrueAction());
      const { status } = await sendSMSToPersonnelService(objData);
      if (status === 200) {
        toastSuccessMessage(`پیامک با موفقیت ارسال شد`);
        handleClosePersonnelModal();
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Send Educational SMS Method
  const handleSendEducationalSMS = async (event) => {
    event?.preventDefault();

    const message = event.target.message.value;

    const objData = { pk: order.id, educational_text: message };

    if (message?.trim()?.length <= 0)
      return toastErrorMessage("متن پیامک نمیتواند خالی باشد");

    try {
      dispatch(setLoadingTrueAction());
      const { status } = await sendEducationalSMSService(objData);
      if (status === 200) {
        toastSuccessMessage(`پیامک با موفقیت ارسال شد`);
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Send Order To Personnel SMS Method
  const handleSendOrderToPersonnelSMS = async (event) => {
    event?.preventDefault();

    const objData = { pk: order.id };
    try {
      dispatch(setLoadingTrueAction());
      const { status } = await sendOrderToPersonnelSMSService(objData);
      if (status === 200) {
        toastSuccessMessage(`پیامک سفارش با موفقیت ارسال شد`);
        handleClosePersonnelModal();
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Get Logs Order Method
  const handleGetLogsOrder = async (id) => {
    const objData = { order_id: id };

    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await getLogsService(objData);
      if (status === 200) {
        setLogs(data.list);
        setIsShowLogs(true);
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Add Personnel Method
  const handleAddPersonnel = async (_prsnl) => {
    // Add to all Personnels
    const prsnl = [...personnel_order];
    const isPersonnel = prsnl.find((p) => p.id === _prsnl?.pk);
    if (prsnl.length >= 1)
      return modalErrorMessage(
        "سفارش نمیتواند چند پرسنل داشته باشد، لطفا پرسنل قبلی را حذف کنید سپس پرسنل جدید را اضافه کنید"
      );
    if (isPersonnel) return toastErrorMessage("پرسنل در لیست موجود است");

    setPersonnel_order([
      ...prsnl,
      { ..._prsnl, personnel_id: _prsnl.pk, id: _prsnl.pk, isNew: true },
    ]);
    // Reset Personnel
    setPersonnels([]);

    // Remove Personnel in deleted
    const deletePrsnl = [...deleted_personnel];
    const deletedPersonnelFiltered = deletePrsnl.filter(
      (p) => p.id !== _prsnl?.pk
    );
    setDeleted_personnel(deletedPersonnelFiltered);
  };

  // Handle Remove Personnel Method
  const handleRemovePersonnel = async (id) => {
    // delete In all Personnel
    const prsnl = [...personnel_order];
    const personnelFiltered = prsnl.filter(
      (p) => p.id !== id && p.isNew !== true
    );
    setPersonnel_order(personnelFiltered);

    // Add To Deletedes
    const deletedPrsnl = [...deleted_personnel];
    const findPersonnel = prsnl.find((p) => p.id === id);
    if (findPersonnel && !findPersonnel.isNew) {
      deletedPrsnl.push(findPersonnel);
      setDeleted_personnel(deletedPrsnl);
    }
  };

  // Handle Get Survey Item List Method
  const handleGetSurveyItemList = async (event) => {
    event?.preventDefault();
    try {
      const { status, data } = await getSurveyItemsService();
      if (status === 200) {
        setSurveyItems(data.list);
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
    }
  };

  // Handle Create Invoice Method
  const handleCreateInvoice = async (event) => {
    event?.preventDefault();

    let total =
      Number(fee) +
      Number(piece) +
      Number(transportation) +
      extraItems?.reduce((acc, item) => acc + Number(item.price), 0) -
      Number(amount) -
      (useWallet ? Number(order?.client?.wallet.current_balance) : 0);

    const _tax = isTax ? Math.floor(total * (+tax / 100)) : 0;

    total += _tax;

    const objData = {
      order_id: order.id,
      fee: Number(fee),
      piece: Number(piece),
      transportation: Number(transportation),
      items: extraItems,
      tax: Number(_tax),
      amount: -1 * Number(amount),
      total,
      is_official,
      method: invoiceMethod,
      ref_num,
      discount_id: null,
      description,
      useWallet,
      is_paid,
      rechargeWallet,
      cleaning_start_time: order?.cleaning_start_time,
      cleaning_end_time: order?.cleaning_end_time,
      send_to_client: order?.send_to_client,
      send_to_personnel: order?.send_to_personnel,
    };

    try {
      dispatch(setLoadingTrueAction());
      const { status } = await createInvoiceService(objData);
      if (status === 201) {
        toastSuccessMessage("فاکتور با موفقیت ایجاد شد");
        handleGetOrder(order.id);
        handleCloseInvoiceModal();

        handleCreateLog(
          order.id,
          `${userInfo.first_name} ${userInfo.last_name
          } فاکتور جدید ایجاد کرد به اجرت: ${fee}، هزینه قطعه: ${piece}، ایاب و ذهاب: ${transportation}،${extraItems
            ?.map((_item) => `${_item.name} ${_item.price}`)
            ?.toString()}، مالیات: ${_tax}، تخفیف:${amount}، نوع پرداخت:${invoiceMethod === 1
              ? "اعتبار (کیف پول)"
              : invoiceMethod === 2
                ? "درگاه پرداخت"
                : "نقدی"
          }، مجموع: ${total}`
        );
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Edit Invoice Method
  const handleEditInvoice = async (event) => {
    event?.preventDefault();

    let total =
      Number(fee) +
      Number(piece) +
      Number(transportation) +
      extraItems?.reduce((acc, item) => acc + Number(item.price), 0) -
      Number(amount);

    const _tax = isTax ? Math.floor(total * (+tax / 100)) : 0;

    total += _tax;

    const objData = {
      id: invoiceId,
      order_id: order.id,
      fee: Number(fee),
      piece: Number(piece),
      transportation: Number(transportation),
      items: extraItems,
      tax: Number(_tax),
      amount: -1 * Number(amount),
      total,
      is_official,
      method: invoiceMethod,
      ref_num,
      discount_id: null,
      description,
      useWallet,
      is_paid,
      rechargeWallet,
    };
    try {
      dispatch(setLoadingTrueAction());
      const { status } = await editInvoiceService(objData);
      if (status === 200 || status === 201) {
        toastSuccessMessage("فاکتور با موفقیت ویرایش شد");
        handleGetOrder(order.id);
        handleCloseInvoiceModal();

        handleCreateLog(
          order.id,
          `${userInfo.first_name} ${userInfo.last_name
          } فاکتور را ویرایش کرد به اجرت: ${fee}، هزینه قطعه: ${piece}، ایاب و ذهاب: ${transportation}،${extraItems
            ?.map((_item) => `${_item.name} ${_item.price}`)
            ?.toString()}، مالیات: ${_tax}، تخفیف:${amount}، نوع پرداخت:${invoiceMethod === 1
              ? "اعتبار (کیف پول)"
              : invoiceMethod === 2
                ? "درگاه پرداخت"
                : "نقدی"
          }، مجموع: ${total}`
        );
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Send Survey Method
  const handleSendSurvey = async () => {
    const objData = {
      id: order.id,
      rating: rate,
      surveyitem_list: surveyItemsSelected,
      feedback: surveyText,
    };

    if (rate <= 0) return toastErrorMessage("انتخاب امتیاز الزامی است");

    try {
      dispatch(setLoadingTrueAction());
      const { status } = await sendSurveyService(objData);
      if (status === 200) {
        toastSuccessMessage("نظرسنجی با موفقیت ویرایش شد");
        handleGetOrder(order.id);
        handleCloseSurveyModal();
        handleCreateLog(
          order.id,
          `${userInfo.first_name} ${userInfo.last_name} نظرسنجی برای سفارش ${order.id} ویرایش کرد`
        );
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
      dispatch(setLoadingFalseAction());
    }
  };

  // Is Existing Survey Item Method
  const isExistingSurveyItem = (id) => {
    return (
      surveyItemsSelected.findIndex((_item) => _item.survey_id === id) !== -1
    );
  };

  // Handle Change Survey Item List Method
  const handleChangeSurveyItemList = async (id) => {
    let allItems = [...surveyItemsSelected];

    const isExisting = isExistingSurveyItem(id);

    if (isExisting) {
      const filtredItems = allItems.filter((_item) => _item.survey_id !== id);
      allItems = filtredItems;
    } else {
      allItems.push({ survey_id: id });
    }

    setSurveyItemsSelected(allItems);
  };

  // Handle Edit Status Method
  const handleEditStatus = async (pk, itemStatus, successFunc) => {
    try {
      if (isShowCanceling && !cancelId)
        return toastErrorMessage("دلیل لغو الزامی میباشد");
      if (isShowFailing && !failingId)
        return toastErrorMessage("دلیل کنسلی الزامی میباشد");

      dispatch(setLoadingTrueAction());
      // Get order details
      const { data: order } = await getOrderService({ id: pk });

      // Edit order status
      const objData = {
        ...order,
        status: itemStatus,
        ...(cancelId && { cancelingReason: Number(cancelId) }),
        ...(failingId && { failing_reason_id: Number(failingId) }),
      };
      const { status } = await editOrderService(objData);
      if (status === 200) {
        toastSuccessMessage("وضعیت با موفقیت ویرایش شد");

        handleGetOrder(order.id);
        handleCloseCancelingModal();
        handleCloseFailingModal();
        handleCreateLog(
          order.id,
          `${userInfo.first_name} ${userInfo.last_name} وضعیت سفارش ${order?.client?.first_name
          } ${order?.client?.last_name} با شماره موبایل ${order?.client?.mobile
          } را از ${config?.STATUS_CHOICES &&
          order?.status >= 0 &&
          config?.STATUS_CHOICES[order?.status]
          } به ${config?.STATUS_CHOICES &&
          itemStatus >= 0 &&
          config?.STATUS_CHOICES[itemStatus]
          } تغییر داد`
        );
        if ([14].includes(itemStatus)) handleEditProgress(90);
        if (!!successFunc) successFunc();
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Edit Return User Status Method
  const handleEditReturnUserStatus = async (
    pk,
    itemStatus,
    successFunc,
    discountData
  ) => {
    try {
      dispatch(setLoadingTrueAction());
      // Get order details
      const { data: order } = await getOrderService({ id: pk });

      // Edit order status
      const objData = {
        ...order,
        ...discountData,
        return_user_status_id: itemStatus,
      };
      const { status } = await editOrderService(objData);
      if (status === 200) {
        toastSuccessMessage("وضعیت بازگشت مشتری با موفقیت ویرایش شد");

        handleGetOrder(order.id);
        handleCreateLog(
          order.id,
          `${userInfo.first_name} ${userInfo.last_name} وضعیت بازگشت مشتری ${order?.client?.first_name
          } ${order?.client?.last_name} با شماره موبایل ${order?.client?.mobile
          } را از ${order?.returnuserstatus?.id >= 0 &&
          returnUserStatusItems[order?.returnuserstatus?.id]
          } به ${itemStatus >= 0 &&
          returnUserStatusItems?.find((_value) => _value.id === itemStatus)
            ?.description
          } تغییر داد`
        );

        if (!!successFunc) successFunc();
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Edit User Method
  const handleEditUser = async (clientPk) => {
    const objData = {
      ...order,
      client_id: clientPk,
    };

    try {
      dispatch(setLoadingTrueAction());
      const { status } = await editOrderService(objData);
      if (status === 200) {
        toastSuccessMessage("کاربر با موفقیت ویرایش شد");
        handleGetOrder(order.id);
        setUsers([]);
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Edit Address Method
  const handleEditAddress = async (event) => {
    event?.preventDefault();

    const objData = {
      ...order?.address,
      address,
    };

    try {
      dispatch(setLoadingTrueAction());
      const { status } = await editAddressService(objData);
      if (status === 200) {
        toastSuccessMessage("آدرس با موفقیت ویرایش شد");
        handleGetOrder(order.id);
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Send Invoice To Client Method
  const handleSendInvoiceToClient = async (id) => {
    try {
      dispatch(setLoadingTrueAction());
      const { status } = await sendInvoiceToClientService(id);
      if (status === 200) {
        toastSuccessMessage("فاکتور با موفقیت برای مشتری ارسال شد");
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Edit Discount Method
  const handleEditDiscount = async (event) => {
    event?.preventDefault();

    const objData = {
      coupon,
      order_id: id,
    };

    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await editDiscountService(objData);
      if (status === 200) {
        toastErrorMessage(data.message);
        if (data.coupon_id) {
          handleGetOrder(id);
        }
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Edit Values Method
  const handleEditValues = async (func) => {
    const message = handleValidationParams(values);

    if (!!message) return toastErrorMessage(message);

    const objData = {
      ...order,
      admin_notification: admin_notification,
      values,
      is_official_invoice,
    };

    try {
      dispatch(setLoadingTrueAction());
      const { status } = await editOrderService(objData);
      if (status === 200) {
        toastSuccessMessage("سفارش با موفقیت ویرایش شد");
        handleGetOrder(order.id);

        handleCreateLog(
          order.id,
          `${userInfo.first_name} ${userInfo.last_name} سفارش ${order.id} را ویرایش کرد`
        );

        // Handle Custom Function
        if (func) {
          func();
        }
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Create Log Method
  const handleCreateLog = async (order_id, change_message) => {
    if (!permission.admin_log_create) return;

    const objData = {
      order_id,
      change_message,
    };

    try {
      const { status } = await createLogService(objData);
      if (status === 200) {
        // Success
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
    }
  };

  // Handle Get Failure Request Method
  const handleGetFailureRequest = async (id) => {
    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await getFailureRequestService(id);
      if (status === 200) {
        setFailureRequest(data);
        if (!isEmpty(data?.customer_satisfaction_item))
          setCustomer_satisfaction_item(data?.customer_satisfaction_item?.id);
        setResult(data?.result);
        setStatus(data?.status);
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Get Failure Request Item List Method
  const handleGetFailureRequestItemList = async (event) => {
    event?.preventDefault();

    const objData = {
      offset: 0,
      limit: 100,
    };
    try {
      const { status, data } = await getFailureRequestItemsService(objData);
      if (status === 200) {
        setFailureRequestItems(data.results);
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
    }
  };

  // Handle Get User Satisfaction Item List Method
  const handleGetUserSatisfactionItemList = async (event) => {
    event?.preventDefault();

    const objData = {
      offset: 0,
      limit: 100,
    };
    try {
      const { status, data } = await getUserSatisfactionItemsService(objData);
      if (status === 200) {
        setUserSatisfactionItems(data.results);
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
    }
  };

  // Handle Create Failure Request Method
  const handleCreateFailureRequest = async (event) => {
    event?.preventDefault();

    if (!request_type) return toastErrorMessage("نوع درخواست الزامی است");

    const objData = {
      order: order.id,
      request_type,
    };

    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await createFailureRequestService(objData);
      if (status === 201) {
        toastSuccessMessage("درخواست با موفقیت ثبت شد");
        handleGetFailureRequest(data.id);
        handleGetOrder(order.id);
        handleCloseCreateFailureAndViolationModal();
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage(response.data?.message);
      }
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Edit Failure Request Method
  const handleEditFailureRequest = async (event, sts) => {
    event?.preventDefault();
    const objData = {
      id: failureRequest.id,
      ...(customer_satisfaction_item && {
        customer_satisfaction_item_id: customer_satisfaction_item,
      }),
      ...(result && { result }),
      ...(comment && { comment }),
      ...(sts && { status: sts }),
    };

    if (sts) {
      if (isEmpty(failureRequest.comment))
        return toastErrorMessage("توضیحات پشتیبانی و امور متخصصین خالی است");
      if (isEmpty(failureRequest.customer_satisfaction_item))
        return toastErrorMessage("چطوری راضیش کردم خالی است");
      if (isEmpty(failureRequest.result))
        return toastErrorMessage("نتیجه نهایی خالی است");
    }

    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await editFailureRequestService(objData);
      if (status === 201) {
        toastSuccessMessage("موفقیت ثبت شد");
        handleGetFailureRequest(failureRequest.id);
        handleGetOrder(order.id);
        setFailureRequest(data);
        setComment("");
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage(response.data?.message);
      }
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Delete Failure Request Method
  const handleDeleteFailureRequest = async (id) => {
    try {
      dispatch(setLoadingTrueAction());
      const { status } = await deleteFailureRequestService(id);
      if (status === 200) {
        toastSuccessMessage(`درخواست ${id} با موفقیت حذف شد`);
        handleCloseCreateFailureAndViolationModal();
        handleGetOrder(order.id);
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Get Failure Request Comment Item List Method
  const handleGetFailureRequestCommentItemList = async (event) => {
    event?.preventDefault();

    const objData = {
      offset: 0,
      limit: 100,
    };
    try {
      const { status, data } = await getFailureRequestCommentItemsService(
        objData
      );
      if (status === 200) {
        setFailureRequestCommentItems(data.results);
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
    }
  };

  // Handle Get Violations Method
  const handleGetViolation = async (id) => {
    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await getViolationService(id);
      if (status === 200) {
        setViolation(data);

        if (!isEmpty(data?.solved)) setSolved_id(data?.solved?.id);
        if (!isEmpty(data?.result)) setResult_id(data?.result?.id);
        setIsPenalty(!!data?.penalty);
        setPenalty(data?.penalty);
        setResult(data?.description);
        setStatus(data?.status);
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Delete Violation Method
  const handleDeleteViolation = async (id) => {
    try {
      dispatch(setLoadingTrueAction());
      const { status } = await deleteViolationService(id);
      if (status === 200) {
        toastSuccessMessage(`تخلف ${id} با موفقیت حذف شد`);
        handleCloseCreateFailureAndViolationModal();
        handleGetOrder(order.id);
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Create Violation Method
  const handleCreateViolation = async (event) => {
    event?.preventDefault();

    if (!request_type) return toastErrorMessage("نوع تخلف الزامی است");
    if (!personnel_id && !old_personnel_id)
      return toastErrorMessage("پرسنل الزامی است");

    const objData = {
      order: order.id,
      type: request_type,
      personnel_id,
      old_personnel_id,
    };

    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await createViolationService(objData);
      if (status === 201) {
        toastSuccessMessage("تخلف با موفقیت ثبت شد");
        handleGetViolation(data.id);
        handleGetOrder(order.id);
        handleCloseCreateFailureAndViolationModal();
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage(response.data?.message);
      }
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Edit Violation Method
  const handleEditViolation = async (event, sts) => {
    event?.preventDefault();

    const objData = {
      id: violation.id,
      ...(comment && { comment }),
      ...(solved_id && { solved_id }),
      ...(result_id && { result_id }),
      ...(result && { description: result }),
      ...(sts && { status: sts }),
      ...(isPenalty && { penalty: +penalty }),
    };

    if (sts) {
      if (isEmpty(violation.comment))
        return toastErrorMessage("توضیحات پشتیبانی و امور متخصصین خالی است");
      if (isEmpty(violation.solved))
        return toastErrorMessage("نظر رسیدگی کننده خالی است");
      if (isEmpty(violation.result))
        return toastErrorMessage("نتیجه نهایی خالی است");
    }

    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await editViolationService(objData);
      if (status === 201) {
        toastSuccessMessage("با موفقیت ثبت شد");
        handleGetViolation(violation.id);
        handleGetOrder(order.id);
        setViolation(data);
        setComment("");
        setSolved_id("");
        setIsPenalty(false);
        setPenalty("");
        setResult_id("");
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage(response.data?.message);
      }
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Remove Penalty Violation Method
  const handleRemovePenaltyViolation = async (item) => {
    const objData = {
      id: item.id,
      is_remove_penalty: true,
    };

    if (!item.status) return toastErrorMessage("تخلف خاتمه نیافته است");
    if (!item?.penalty) return toastErrorMessage("جریمه قبلا بخشیده شده است");

    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await editViolationService(objData);
      if (status === 201) {
        toastSuccessMessage(data.message);
        handleGetOrder(order.id);
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage(response.data?.message);
      }
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Get Violation Type Item List Method
  const handleGetViolationTypeItemList = async (event) => {
    event?.preventDefault();

    const objData = {
      offset: 0,
      limit: 100,
    };
    try {
      const { status, data } = await getViolationTypeItemsService(objData);
      if (status === 200) {
        setViolationTypeItems(data.results);
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
    }
  };

  // Handle Get Violation Result Item List Method
  const handleGetViolationResultItemList = async (event) => {
    event?.preventDefault();

    const objData = {
      offset: 0,
      limit: 100,
    };
    try {
      const { status, data } = await getViolationResultItemsService(objData);
      if (status === 200) {
        setViolationResultItems(data.results);
        setTotalCount(data.count);
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
    }
  };

  // Handle Get Violation Solved Item List Method
  const handleGetViolationSolvedItemList = async (event) => {
    event?.preventDefault();

    const objData = {
      offset: 0,
      limit: 100,
    };
    try {
      const { status, data } = await getViolationSolvedItemsService(objData);
      if (status === 200) {
        setViolationSolvedItems(data.results);
        setTotalCount(data.count);
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
    }
  };

  // Handle Get Violation Comment Item List Method
  const handleGetViolationCommentItemList = async (event) => {
    event?.preventDefault();

    const objData = {
      offset: 0,
      limit: 100,
    };
    try {
      const { status, data } = await getViolationCommentItemsService(objData);
      if (status === 200) {
        setViolationCommentItems(data.results);
        setTotalCount(data.count);
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
    }
  };

  // Handle Get Canceling Reason List Method
  const handleGetCancelingReasonList = async () => {
    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await getCancelingReasonService();
      if (status === 200) {
        setCancelingItems(data.list);
        handleShowCancelingModal();
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Get Failing Reason Item List Method
  const handleGetFailingReasonItemList = async () => {
    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await getFailingReasonService();
      if (status === 200) {
        setFailingReasonItems(data.results);
        handleShowFailingModal();
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Get Return User Status Item List Method
  const handleGetReturnUserStatusItemList = async () => {
    try {
      const { status, data } = await getReturnUserStatusService();
      if (status === 200) {
        setReturnUserStatusItems(data.results);
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
    }
  };

  // Handle Edit User Info Method
  const handleEditUserInfo = async (userData) => {
    const objData = {
      ...order.client,
      ...userData,
    };

    try {
      dispatch(setLoadingTrueAction());
      const { status } = await editUserService(objData);
      if (status === 200 || status === 201) {
        toastSuccessMessage(
          `${objData.first_name} ${objData.last_name} با موفقیت ویرایش شد`
        );
        handleGetOrder(order.id);
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage(response?.data?.error);
      }
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Edit Value
  const handleEditValue = (data, _value) => {
    let vals = [...values];
    let valIndex = vals?.findIndex((v) => v?.parameter === data?.parameter);
    let val = vals[valIndex];
    val.value = _value;
    vals[valIndex] = val;
    setValues(vals);
  };

  const handleValidationParams = () => {
    for (const item of values) {
      switch (item.type) {
        // Check Radio Button Type
        case "radiobutton":
          if (item.value !== 0 && !item.value)
            return `${item.description_extra}: ${item.alert}`;
          break;
        // Check Text Type
        case "text":
          break;
        // Check Switch Type
        case "switch":
          break;
        // Check Multiple Choice Type
        case "multiplechoice":
          if (item.value !== 0 && !item.value)
            return `${item.description_extra}: ${item.alert}`;
          break;
        // Check Date Time Type
        case "datetime":
          if (!item.value) return `${item.description_extra}: ${item.alert}`;
          break;
        // Check Number Type
        case "number":
          if (!(item.value <= item.max && item.value >= item.min)) {
            item.value = item.default;
            return `${item.description_extra}: بازه انتخابی باید بین ${item.min} تا ${item.max} باشد`;
          }
          break;
        // Check Item Type
        case "item":
          if (item.values || !`${item.description_extra}: ${item.alert}`) {
            if (item.values[0].type === "number") {
              const isNumberExistence =
                item.values.findIndex((v) => v.value > 0) !== -1;
              if (!isNumberExistence) {
                return `${item.description_extra}: ${item.alert}`;
              }
            } else if (item.values[0].type === "radiobutton") {
              for (let i = 0; i < item.values.length; i++) {
                const _item = item.values[i];
                if (!_item.value && _item.value !== 0)
                  return `${item.description_extra}: ${item.alert}`;
              }
            }
          } else return `${item.description_extra}: ${item.alert}`;
          break;

        default:
          break;
      }
    }
  };

  // Handle Add Comment Method
  const handleAddComment = async (event, parent_id) => {
    event?.preventDefault();

    const text = event?.target?.comment?.value;

    const objData = {
      order_id: order.id,
      text,
      ...(parent_id && { parent_id }),
    };

    try {
      dispatch(setLoadingTrueAction());
      const { status } = await addOrderCommentService(objData);
      if (status === 200 || status === 201) {
        toastSuccessMessage("نظر شما با موفقیت ثبت شد");
        event.target.comment.value = "";
        handleGetOrder(order.id);
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Edit Progress Method
  const handleEditProgress = async (progress) => {
    try {
      dispatch(setLoadingTrueAction());
      // Get order details
      const { data: newOrder } = await getOrderService({ id: order.id });

      const objData = {
        ...newOrder,
        progress,
      };
      const { status } = await editOrderService(objData);
      if (status === 200) {
        toastSuccessMessage("پیشرفت با موفقیت ویرایش شد");
        handleGetOrder(order.id);

        handleCreateLog(
          order.id,
          `${userInfo.first_name} ${userInfo.last_name} پیشرفت سفارش ${order.id
          } را به ${orderProgressToText(progress)} ویرایش کرد`
        );
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Check Discount Method
  const handleCheckDiscount = async (event) => {
    event?.preventDefault();

    const objData = {
      unique_id,
      coupon,
    };

    if (!coupon) return toastErrorMessage("کد تخفیف الزامی میباشد");

    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await checkDiscountService(objData);
      if (status === 200) {
        if (data.message) {
          toastErrorMessage(data.message);
        } else {
          toastSuccessMessage("کد تخفیف با موفقیت اعمال شد");
          setCouponInfo(data);
        }
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage(response?.data?.error);
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  const checkViewOrders = (id, isView) => {
    const viewedOrders = JSON.parse(localStorage.getItem("viewedOrders")) || [];
    const isViewd = viewedOrders.includes(+id);
    if (isView && !isViewd) {
      localStorage.setItem(
        "viewedOrders",
        JSON.stringify([...viewedOrders, +id])
      );
    }
    return isViewd;
  };

  // Handle Save Order Cleaning Parameters Method
  const handleSaveOrderCleaningParams = async (cleaningData, successCallback) => {
    const objData = {
      ...order,
      ...cleaningData,
    };

    try {
      dispatch(setLoadingTrueAction());
      const { status } = await editOrderService(objData);
      if (status === 200) {
        toastSuccessMessage("اطلاعات نظافت و فاکتور با موفقیت ذخیره شد");
        handleGetOrder(order.id);
        if (successCallback) successCallback();
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  return (
    <orderAdminContext.Provider
      value={{
        orders,
        setOrders,
        personnels,
        setPersonnels,
        personnel,
        setPersonnel,
        couponInfo,
        setCouponInfo,
        order,
        setOrder,
        client,
        setClient,
        categories,
        setCategories,
        categoriesWithId,
        setCategoriesWithId,
        filterCategory,
        setFilterCategory,
        values,
        setValues,
        surveyItems,
        setSurveyItems,
        personnel_order,
        setPersonnel_order,
        deleted_personnel,
        setDeleted_personnel,
        logs,
        setLogs,
        comments,
        setComments,
        employers,
        setEmployers,
        services,
        setServices,
        config,
        setConfig,
        search,
        setSearch,
        totalCount,
        setTotalCount,
        pageNumber,
        setPageNumber,
        managedCities,
        setManagedCities,
        selectedCities,
        setSelectedCities,
        limit,
        setLimit,
        id,
        setId,
        invoiceId,
        setInvoiceId,
        rate,
        setRate,
        sort_by,
        setSort_by,
        addresses,
        setAddresses,
        failureRequest,
        setFailureRequest,
        failureRequestItems,
        setFailureRequestItems,
        violationTypeItems,
        setViolationTypeItems,
        violationSolvedItems,
        setViolationSolvedItems,
        violationResultItems,
        setViolationResultItems,
        violationCommentItems,
        setViolationCommentItems,
        userSatisfactionItems,
        setUserSatisfactionItems,
        failureRequestCommentItems,
        setFailureRequestCommentItems,
        cancelingItems,
        setCancelingItems,
        failingReasonItems,
        setFailingReasonItems,
        returnUserStatusItems,
        setReturnUserStatusItems,
        violation,
        setViolation,
        personnelSearch,
        setPersonnelSearch,
        unique_id,
        setUnique_id,
        address_id,
        setAddress_id,
        category,
        setCategory,
        employer,
        setEmployer,
        service,
        setService,
        status,
        setStatus,
        to_date,
        setTo_date,
        from_date,
        setFrom_date,
        lastDay,
        setLastDay,
        users,
        setUsers,
        userSearch,
        setUserSearch,
        personnelStep,
        setPersonnelStep,
        isUserLoading,
        setIsUserLoading,
        personnel_notification,
        setPersonnel_notification,
        isSpecial,
        setIsSpecial,
        isShowLogs,
        setIsShowLogs,
        isShowPersonnelModal,
        setIsShowPersonnelModal,
        isPersonnelLoading,
        setIsPersonnelLoading,
        personnelType,
        setPersonnelType,
        comment,
        setComment,
        result,
        setResult,
        request_type,
        setRequest_type,
        personnel_id,
        setPersonnel_id,
        old_personnel_id,
        setOld_personnel_id,
        solved_id,
        setSolved_id,
        penalty,
        setPenalty,
        isPenalty,
        setIsPenalty,
        result_id,
        setResult_id,
        customer_satisfaction_item,
        setCustomer_satisfaction_item,
        isShowSurveyModal,
        setIsShowSurveyModal,
        isPositiveTab,
        setIsPositiveTab,
        isExistingSurveyItem,
        surveyItemsSelected,
        setSurveyItemsSelected,
        isEditAddress,
        setIsEditAddress,
        address,
        setAddress,
        admin_notification,
        setAdmin_notification,
        expert_type,
        setExpert_type,
        activity_type,
        setActivity_type,
        isActive,
        setIsActive,
        workCount,
        setWorkCount,
        coupon,
        setCoupon,
        fee,
        setFee,
        piece,
        setPiece,
        surveyText,
        setSurveyText,
        transportation,
        setTransportation,
        extraItems,
        setExtraItems,
        is_official_invoice,
        setIs_official_invoice,
        tax,
        setTax,
        is_official,
        setIs_official,
        useWallet,
        setUseWallet,
        is_paid,
        setIs_paid,
        rechargeWallet,
        setRechargeWallet,
        isTax,
        setIsTax,
        amount,
        setAmount,
        invoiceMethod,
        setInvoiceMethod,
        ref_num,
        setRef_num,
        description,
        setDescription,
        cancelId,
        setCancelId,
        failingId,
        setFailingId,
        isShowInvoiceModal,
        setIsShowInvoiceModal,
        handleCreateInvoice,
        handleEditInvoice,
        isShowDetailsModal,
        setIsShowDetailsModal,
        isShowCreateModal,
        setIsShowCreateModal,
        isShowCreateFailureRequestModal,
        setIsShowCreateFailureRequestModal,
        isShowCreateViolationModal,
        setIsShowCreateViolationModal,
        isShowAdvancedSearch,
        setIsShowAdvancedSearch,
        isShowFilter,
        setIsShowFilter,
        isShowCanceling,
        setIsShowCanceling,
        isShowFailing,
        setIsShowFailing,
        isShowEditModal,
        setIsShowEditModal,
        handleShowEditModal,
        handleCloseEditModal,
        handleCloseCreateFailureAndViolationModal,
        handleGetAddresses,
        handleGetService,
        handleShowDetailsModal,
        handleCloseDetailsModal,
        handleShowCreateModal,
        handleCloseCreateModal,
        handleShowCancelingModal,
        handleCloseCancelingModal,
        handleShowFailingModal,
        handleCloseFailingModal,
        handleChangeSurveyItemList,
        handleGetPersonnel,
        handleGetUsers,
        handleShowSurveyModal,
        handleCloseSurveyModal,
        handleEditPersonnel,
        handleShowPersonnelModal,
        handleClosePersonnelModal,
        handleShowInvoiceModal,
        handleCloseInvoiceModal,
        handleGetOrders,
        handleGetOrder,
        handleDeleteOrder,
        handleGetCategoryItemList,
        handleSendSMSToPersonnel,
        handleSendEducationalSMS,
        handleSendOrderToPersonnelSMS,
        handleGetLogsOrder,
        handleGetPersonnels,
        handleRemovePersonnel,
        handleAddPersonnel,
        handleGetSurveyItemList,
        handleSendSurvey,
        handleEditStatus,
        handleEditReturnUserStatus,
        handleEditUser,
        handleEditAddress,
        handleSendInvoiceToClient,
        handleEditDiscount,
        handleResetState,
        handleEditValue,
        handleEditValues,
        handleGetEmployers,
        handleSearchServices,
        handleGetServices,
        handleCreateOrder,
        handleGetFailureRequest,
        handleGetFailureRequestItemList,
        handleGetUserSatisfactionItemList,
        handleDeleteFailureRequest,
        handleCreateFailureRequest,
        handleEditFailureRequest,
        handleGetFailureRequestCommentItemList,
        handleGetViolation,
        handleDeleteViolation,
        handleCreateViolation,
        handleEditViolation,
        handleRemovePenaltyViolation,
        handleGetViolationTypeItemList,
        handleGetViolationResultItemList,
        handleGetViolationSolvedItemList,
        handleGetViolationCommentItemList,
        handleGetCancelingReasonList,
        handleGetFailingReasonItemList,
        handleGetReturnUserStatusItemList,
        handleEditUserInfo,
        handleAddComment,
        handleEditProgress,
        handleCheckDiscount,
        handleResetCoupon,
        checkViewOrders,
        cities,
        city_filter,
        setCity_filter,
        personnelSort,
        setPersonnelSort,
        handleSaveOrderCleaningParams,
      }}
    >
      {children}
    </orderAdminContext.Provider>
  );
};

export default OrderAdminContext;
